export default "__VITE_ASSET__BZh2kzar__"